import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment.development';
import {controllersNames} from '../controllersNames';
import {PendingCounts} from '../interfaces/users/PendingCounts';

/**
 * Админские счётчики «новых событий»: комментарии на модерации,
 * заявки на оплату, свежие регистрации (api/Users/PendingCounts).
 */
@Injectable({providedIn: 'root'})
export class PendingCountsService {
  private http = inject(HttpClient);

  private readonly api = environment.apiBase + '/' + controllersNames.users;

  /** Админ: счётчики того, что требует реакции. */
  getPendingCounts() {
    return this.http.get<PendingCounts>(this.api + '/PendingCounts');
  }
}
